/**
 * <pvz-contact-form>
 *
 * お問い合わせフォームの「注文番号」欄の出し分け。
 * お問い合わせ内容が data-order-topic と一致したときだけ表示する。
 *
 * 隠している間は input を disabled にして送信対象から外す
 * (空の「注文番号」が通知メールに並ばないようにするため)。
 *
 * Markup:
 *   <pvz-contact-form data-order-topic="ご注文について">
 *     <select data-pvz-contact-topic>…</select>
 *     <div data-pvz-contact-order hidden><input …></div>
 *   </pvz-contact-form>
 */
if (!customElements.get('pvz-contact-form')) {
  customElements.define(
    'pvz-contact-form',
    class PerverzeContactForm extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('[data-pvz-contact-topic]');
        this.orderField = this.querySelector('[data-pvz-contact-order]');
        if (!this.select || !this.orderField) return;

        this.orderInput = this.orderField.querySelector('input');
        this.orderTopic = (this.dataset.orderTopic || '').trim();

        this.update = this.update.bind(this);
        this.select.addEventListener('change', this.update);
        // 戻るボタンなどで選択が復元されている場合に備えて初期状態も反映する
        this.update();
      }

      update() {
        const show = this.orderTopic !== '' && this.select.value.trim() === this.orderTopic;

        this.orderField.hidden = !show;
        if (this.orderInput) {
          this.orderInput.disabled = !show;
          if (!show) this.orderInput.value = '';
        }
      }
    }
  );
}
